import { render } from "./Stand.vue?vue&type=template&id=ad4a8f44"
import script from "./Stand.vue?vue&type=script&lang=js"
export * from "./Stand.vue?vue&type=script&lang=js"

import "./Stand.vue?vue&type=style&index=0&id=ad4a8f44&lang=scss"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__